// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3Gszc","errorLogs":"styles_errorLogs__ZtWTu"};